<template>
  <div>
    <div style="height: 60px; display: flex; ">
      <div style="width: 240px; display: flex; align-items: center; padding-left: 20px; background-color: #3a456b">
          <img style="width: 40px; height: 40px; border-radius: 50%;" src="@/assets/logo.png" alt=""></img>
          <span style="font-size: 15px; font-weight: bold; color:#f1f1f1;margin-left: 5px; ">资料管理系统</span>
          
      </div>
      <div style="flex: 1; display: flex; align-items: center;margin-left: 20px; border-bottom:1px solid #ddd">
          <span style="margin-right: 5px; cursor: pointer;" @click="router.push('/manager/home')">首页</span> / <span style="margin-left: 5px;">{{ router.currentRoute.value.meta.name }}</span>
      </div>
      <div style="width: fit-content; padding-right: 20px;  display: flex; align-items: center;">
        <el-dropdown>
          <div style="display: flex; align-items: center;">
              <!-- <img src="http://localhost:9999/files/download/1758004162673-666.png"></img> -->
              <img v-if="data.user?.avater" :src="data.user?.avater"    style="width: 40px; height: 40px; border-radius: 50%"></img>
              <img v-else style="width: 40px; height: 40px; border-radius: 50%"  src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></img>
              <span style="margin-left: 5px;">{{ data.user.name }}</span>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
                <el-dropdown-item @click="router.push('/manager/person')">个人信息</el-dropdown-item>
                <el-dropdown-item @click="router.push('/manager/updatePassword')">修改密码</el-dropdown-item>
                <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        
        </el-dropdown>
        
      </div>
    </div>

    <!-- 下方区域 -->
     <div style="display: flex; height: calc(100vh - 60px); overflow-x: hidden; overflow-y: auto;">
        <!-- 菜单区域开始 -->
     <div style="width: 240px; ">
        <el-menu router 
        background-color="#3a456b"
        text-color="#fff"
        active-text-color="#fff"
        :default-openeds="['1']" 
        :default-active="1" 
        style="min-height: calc(100vh - 60px);">
               
            <el-menu-item index="/manager/home">
                <el-icon><House /></el-icon>
                <span>首页</span>
            </el-menu-item>
                <el-sub-menu index="1">
                <template #title>
                    <el-icon><location /></el-icon>
                    <span>数据管理</span>
                </template>
                <el-menu-item index="/manager/userData">数据信息</el-menu-item>
                <el-menu-item index="/manager/admin">管理员信息</el-menu-item>
                <!-- <el-menu-item index="/manager/user">普通用户信息</el-menu-item> -->
                
                </el-sub-menu>
                </el-menu>
     </div>
     <!-- 菜单区域结束 -->

     <!-- 数据渲染区域开始 -->
      <div style="flex: 1; width: 0; padding: 10px; background-color:#f2f4ff; overflow: auto;">
          <RouterView @updateUser="updateUser"></RouterView>
          <!-- <RouterView/> -->
      </div>

      <!-- 数据渲染区域结束 -->
     </div>
     <!-- 下方区域结束 -->
  </div>
  
</template>

<script setup >
import router from "@/router/index.js";
import { reactive } from 'vue';
const data = reactive({
    user: JSON.parse(localStorage.getItem('code_user') || "{}")
})
console.log('989898989899',data.user)

const logout = () => {
  localStorage.removeItem('code_user')
  location.href = '/login'
}

const updateUser = () => {
  console.log('--------------------------------------')
  data.user = JSON.parse(localStorage.getItem("code_user") || '{}')
}

if(!data.user?.id){
    location.href = '/login';
}
</script>

<style scoped>

    /* .el-menu.el-menu--vertical{
      min-height: 100%!important;
} */

.el-tooltip__trigger{
  outline: none!important;
}
</style>